import { Flow } from 'signup-constants/Flow';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsOAuthExistingUser } from '../store/app/selectors';
import { isFlow } from '../utils/isFlow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
import { getIsComingFromEmailSignatureGenerator } from './externalExperimentUrils';
import { enrollOnFlow } from './experimentDefaults';
import { getIsGoogleCredentialAuthentication } from '../google-authentication/google-prompt/useGoogleCredentialForAuthentication';
import { getHasAcq0141TrackingParam } from './acq0141/acq0141Utils';
import { getIsMobile } from '../utils/deviceUtils';
import { isBrowserAndApplicationLanguageForLocale } from '../i18n/LanguageUtils';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getPreferredLocale } from '../i18n/LocaleUtils';
import { isHubless } from '../store/existing-accounts/selectors';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ0142, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales]);
    const isNewUser = getIsOAuthExistingUser(state) || getIsNewUserExperiment(state);
    const intentKey = getIntentKey();
    const isComingFromEmailSignatureGenerator = getIsComingFromEmailSignatureGenerator();
    const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
    const isAssignedToACQ141 = getHasAcq0141TrackingParam();
    return isEnrolledFlow && isNewUser && !intentKey && !isComingFromEmailSignatureGenerator && !isComingFromGooglePrompt && !isAssignedToACQ141;
  }
}], [ExperimentKeys.ACQ0143, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const intentKey = getIntentKey();
    const isMobile = getIsMobile();
    const isFrenchLanguage = isBrowserAndApplicationLanguageForLocale(Locale.fr) || getPreferredLocale() === Locale.fr;
    const userIsHubless = isHubless(state);
    return isEnrolledFlow && !intentKey && !isMobile && !isFrenchLanguage && !userIsHubless;
  }
}], [ExperimentKeys.ACQ0144, {
  shouldEnroll: () => {
    const isEnrolledFlow = isFlow([]);
    return isEnrolledFlow;
  }
}], [ExperimentKeys.WP0078, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Microapp, Flow.Marketing, Flow.Sales]);
    const isNewUserExperiment = getIsNewUserExperiment(state);
    return isEnrolledFlow && isNewUserExperiment;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }
  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}